import { FC } from "react";
import { FreeDeliveryNotificationType } from "../CartTypes";
import styles from "./FreeShipping.module.scss";
import FormattedPrice from "@/components/UI/FormattedPrice/FormattedPrice";

interface FreeShipping {
	freeShippingNotification: FreeDeliveryNotificationType;
	cartTotal: number;
}

export const FreeShipping: FC<FreeShipping> = ({
	freeShippingNotification,
	cartTotal,
}) => {
	if (!freeShippingNotification?.enable) return null;

	if (cartTotal >= freeShippingNotification.threshold) {
		return (
			<div className={styles.freeShipping}>
				{freeShippingNotification.afterThresholdMetText}
			</div>
		);
	}

	const remainingAmount = freeShippingNotification.threshold - cartTotal;

	const textSplit =
		freeShippingNotification?.beforeThresholdMetText?.split("<amount>");

	return (
		<div className={styles.freeShipping}>
			{textSplit[0]} <FormattedPrice price={remainingAmount} /> {textSplit[1]}
		</div>
	);
};
